export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadzenie:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontynuuj"])}
}